import script from "./foot-nav.vue?vue&type=script&lang=ts&setup=true"
export * from "./foot-nav.vue?vue&type=script&lang=ts&setup=true"

import "./foot-nav.vue?vue&type=style&index=0&id=4e43b1ac&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e43b1ac"]])

export default __exports__